import { provideServiceWorker } from '@angular/service-worker';

interface CoreServiceWorkerConfig {
  enabled: boolean;
  script?: string;
}

export const provideCoreServiceWorker = (config: CoreServiceWorkerConfig) => provideServiceWorker(
  config.script ?? 'ngsw-worker.js', {
    enabled: config.enabled,
    registrationStrategy: 'registerImmediately',
  }
);
